import React, { useEffect, useState } from 'react'
import LoadingSpinner from './components/LoadingSpinner'
import axios from 'axios'
import { ConfigProvider, message } from 'antd'
import viVN from 'antd/es/locale/vi_VN'
import moment from 'moment'
import 'moment/locale/vi'
import ThemeProvider from './providers/ThemeProvider'
// React Router
import { Redirect, Route, Router, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
// MobX
import { Provider } from 'mobx-react'
import 'mobx-react-lite/batchingForReactDom'
import loadingAnimationStore from './stores/loadingAnimationStore'
import commonStore from './stores/commonStore'
import authenticationStore from './stores/authenticationStore'
import userStore from './stores/userStore'
import userGroupStore from './stores/userGroupStore'
import commandStore from './stores/commandStore'
import companyStore from './stores/companyStore'
import accountStore from './stores/accountStore'
import accountEditStore from './stores/accountEditStore'
import positionStore from './stores/positionStore'
import notificationStore from './stores/notificationStore'
import departmentStore from './stores/departmentStore'
import fileStore from './stores/fileStore'
import authorityStore from './stores/authorityStore'
import bookStore from './stores/bookStore'
import staffStore from './stores/staffStore'
import workScheduleStore from './stores/workScheduleStore'
import connectedDocumentStore from './stores/connectedDocumentStore'
import connectedCommitteeDocumentStore from './stores/connectedCommitteeDocumentStore'
import internalDocumentStore from './stores/internalDocumentStore'
import sampleDocumentStore from './stores/sampleDocumentStore'
import taskManagementStore from './stores/taskManagementStore'
import taskManagementCommentStore from './stores/taskManagementCommentStore'
import chuTruongStore from './stores/chuTruongStore'
import chuTruongCommentStore from './stores/chuTruongCommentStore'
import roleStore from './stores/roleStore'
import statisticStore from './stores/statisticStore'
import organizationStore from './stores/organizationStore'
import documentStore from './stores/documentStore'
import leavePageStore from './stores/leavePageStore'
import phieuTrinhFakeDataStore from './stores/phieuTrinhFakeDataStore'
import timesheetsStore from './stores/timesheetsStore' //Bỏ, thay bằng ChamCongStore
import chamCongStore from './stores/chamCongStore' //Bỏ, thay bằng ChamCongStore
import tintucStore from './stores/tintucStore'
import workStore from './stores/workStore'
import voteStore from './stores/voteStore'
import payslipStore from './stores/payslipStore'
import proposalStore from './stores/proposalStore'
import taskStore from './stores/taskStore'
import selectUserStore from './stores/selectUserStore'
import consultStore from './stores/ConsultStore'
import consultCommentStore from './stores/consultCommentStore'
import signedDocumentStore from './stores/signedDocumentStore'
import signAccountStore from './stores/signAccountStore'
import electronicDocumentStore from './stores/electronicDocumentStore'
import selectPeopleStore from './stores/selectPeopleStore'
import messagesStore from './stores/messagesStore'
import internalMessageStore from './stores/internalMessageStore'
import userTrucStore from './stores/userTrucStore'
import kpiStore from './stores/kpiStore'
import kpiQuarterPageStore from './pages/KpiQuarterPage/KpiQuarterPageStore'
import moduleStore from './stores/moduleStore'
import salaryStore from './stores/salaryStore'
import aclStore from './stores/aclStore'
import commonServiceStore from './stores/commonServiceStore'
import proposalAdvanceStore from './stores/proposalAdvanceStore'
import listHistoryLogStore from './pages/ListHistoryLog/ListHistoryLogStore'
import isoDocumentStore from './pages/ISODocumentPage/isoDocumentStore'
import contentTemplateStore from './pages/ContentTemplate/contentTemplateStore'
import documentAccessibilityStore from './stores/documentAccessibilityStore'
import proposalSalaryStore from './stores/proposalSalaryStore'
import salaryVpStore from './stores/salaryVpStore'
import resourcesStore from './pages/MyDocumentPage/ResourcesStore'
// Pages
import NotFoundPage from './pages/NotFoundPage'
import DashboardPageV2 from './pages/DashboardPageV2'

//ProposalPage
//Demo
import DemoTagPage from './pages/Demo/index'

// Styling
import './App.less'

import { normalRoutes, routes } from './routes'
import Report from './components/MainSidebar/Report'

//keycloak
import { ReactKeycloakProvider, useKeycloak } from '@react-keycloak/web'
import keycloak from './keycloak'
import { useSSO } from './config'
import approvalTemplateStore from './stores/approvalTemplateStore'
import FeedbackProcedureStore from './stores/FeedbackProcedureStore'
import FeedbackCommentStore from './stores/FeedbackCommentStore'
import riskStore from './stores/riskStore'
import reportStore from './stores/reportStore'
import actionStore from './stores/actionStore'
import riskAriseStore from './stores/riskAriseStore'
import riskTemplateStore from './stores/riskTemplateStore'
import riskUnitUserStore from './stores/risk/riskUnitUserStore'
import riskUnitStore from './stores/risk/riskUnitStore'
import proposalTypeStore from './stores/proposalTypeStore'
import boardResolutionMinutesStore from './stores/boardResolutionMinutesStore'
import boardReportStore from './stores/boardReportStore'

const history = createBrowserHistory()

const rootStore = {
  loadingAnimationStore,
  commonStore,
  authenticationStore,
  userStore,
  userGroupStore,
  commandStore,
  companyStore,
  accountStore,
  accountEditStore,
  positionStore,
  notificationStore,
  departmentStore,
  connectedDocumentStore,
  internalDocumentStore,
  connectedCommitteeDocumentStore,
  fileStore,
  authorityStore,
  bookStore,
  staffStore,
  workScheduleStore,
  taskManagementStore,
  sampleDocumentStore,
  roleStore,
  taskManagementCommentStore,
  statisticStore,
  organizationStore,
  documentStore,
  boardResolutionMinutesStore,
  boardReportStore,
  leavePageStore,
  phieuTrinhFakeDataStore,
  timesheetsStore,
  chamCongStore,
  payslipStore,
  proposalStore,
  approvalTemplateStore,
  taskStore,
  selectUserStore,
  consultStore,
  consultCommentStore,
  signedDocumentStore,
  signAccountStore,
  tintucStore,
  workStore,
  chuTruongCommentStore,
  chuTruongStore,
  electronicDocumentStore,
  selectPeopleStore,
  messagesStore,
  internalMessageStore,
  userTrucStore,
  kpiQuarterPageStore,
  kpiStore,
  salaryStore,
  aclStore,
  commonServiceStore,
  moduleStore,
  proposalAdvanceStore,
  proposalSalaryStore,
  salaryVpStore,
  listHistoryLogStore,
  isoDocumentStore,
  contentTemplateStore,
  documentAccessibilityStore,
  voteStore,
  FeedbackProcedureStore,
  FeedbackCommentStore,
  actionStore,
  riskStore,
  riskAriseStore,
  riskTemplateStore,
  riskUnitUserStore,
  riskUnitStore,
  reportStore,
  proposalTypeStore,
  resourcesStore,
}

const KEYCLOAK_MIN_VALIDITY_SECONDS = 60
let keycloakTokenRefreshPromise

const saveToken = tokenValue => {
  if (tokenValue) {
    let objToken = {
      access_token: tokenValue,
    }
    localStorage.setItem('jwt', JSON.stringify(objToken))
    authenticationStore.setAppToken(JSON.stringify(objToken))
    // console.log('Update access_token', objToken)
  }
}

const getTokenPayload = tokenValue => {
  try {
    const [, payload] = tokenValue.split('.')
    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(window.atob(normalizedPayload))
  } catch (error) {
    return undefined
  }
}

const getStoredToken = () => {
  try {
    const token = localStorage.getItem('jwt') || sessionStorage.getItem('jwt')
    return token ? JSON.parse(token).access_token : undefined
  } catch (error) {
    return undefined
  }
}

const hasValidStoredToken = () => {
  const token = getStoredToken()
  const payload = token && getTokenPayload(token)

  return Boolean(payload?.exp && payload.exp * 1000 > Date.now())
}

const refreshKeycloakTokenIfNeeded = async () => {
  if (!useSSO || !keycloak?.authenticated || !keycloak?.token) return

  try {
    if (!keycloakTokenRefreshPromise) {
      keycloakTokenRefreshPromise = keycloak
        .updateToken(KEYCLOAK_MIN_VALIDITY_SECONDS)
        .then(() => {
          saveToken(keycloak.token)
        })
        .finally(() => {
          keycloakTokenRefreshPromise = undefined
        })
    }

    await keycloakTokenRefreshPromise
  } catch (error) {
    if (hasValidStoredToken()) return

    authenticationStore.userLogout()
    throw error
  }
}

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      hasValidStoredToken() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
)

axios.defaults.timeout = 60000
axios.interceptors.request.use(
  async config => {
    await refreshKeycloakTokenIfNeeded()

    if (useSSO && keycloak?.token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${keycloak.token}`
    } else if (authenticationStore.appToken) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${
        JSON.parse(authenticationStore.appToken).access_token
      }`
    }

    return config
  },
  error => Promise.reject(error)
)
axios.interceptors.response.use(
  response => response,
  error => {
    if (axios.isCancel(error)) {
      return Promise.resolve()
    }
    if (error?.response?.status === 408 || error?.code === 'ECONNABORTED') {
      message.config({
        maxCount: 1,
      })
      message.error('Request timeout!')
      authenticationStore.userLogout()
      history.push('/login')
    }

    var errorMessage = error?.response?.data?.errorMessage?.messages
    if (errorMessage) {
      errorMessage.errorCode = error?.response?.data?.errorMessage?.errorCode
    }

    return Promise.reject(
      errorMessage || {
        vi: 'Đã có lỗi xảy ra trong quá trình kết nối!',
      }
    )
  }
)

moment.locale('vi', {
  week: {
    dow: 1,
  },
})

const App = () => {
  const [ready, setReady] = useState(false)

  const eventLogger = (event, error) => {
    // console.log('onKeycloakEvent', event, error)

    if (
      event.toString() === 'onReady' ||
      (event.toString() === 'onInitError' && hasValidStoredToken())
    ) {
      setReady(true)
    }
  }

  const tokenLogger = tokens => {
    // console.log('tokenLogger', tokens)

    if (tokens.token) {
      saveToken(tokens.token)
    }
  }

  const keycloakProviderInitConfig = {
    onLoad: 'login-required',
  }

  return useSSO ? (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={keycloakProviderInitConfig}
      onEvent={eventLogger}
      onTokens={tokenLogger}>
      {ready ? <AppRouter /> : <p />}
    </ReactKeycloakProvider>
  ) : (
    <AppRouter />
  )
}

export const AppRouter = () => {
  return useSSO ? <SSOAppRouter /> : <NonSSOAppRouter />
}

const SSOAppRouter = () => {
  const { keycloak } = useKeycloak()

  return (
    <AppRouterContent
      appToken={keycloak.token || authenticationStore.appToken}
      routeToken={keycloak.token}
    />
  )
}

const NonSSOAppRouter = () => {
  return (
    <AppRouterContent
      appToken={authenticationStore.appToken}
      routeToken={authenticationStore.appToken}
    />
  )
}

const AppRouterContent = ({ appToken, routeToken }) => {
  useEffect(() => {
    console.log('useSSO', useSSO, process.env.REACT_APP_USE_SSO)
  }, [])

  useEffect(
    () => {
      // console.log('useEffect. keycloak.token', routeToken)
      if (useSSO) {
        saveToken(routeToken)
      }
    },
    [routeToken]
  )

  useEffect(
    () => {
      // console.log('useEffect. check session login')
      if (!appToken) return
      ;(async () => {
        loadingAnimationStore.showSpinner(true)
        try {
          const { data } = await authenticationStore.checkCurrentUser()
          await Promise.all([
            aclStore.getACLDetailByUser(data.username),
            commandStore.getCommandList(),
            accountStore.getCurrentUserAccount(),
            moduleStore.getModuleList(),
            companyStore.getCompanyList(),
          ])
        } catch (err) {
          history.push('/login')
          localStorage.clear()
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      })()
    },
    [appToken]
  )

  useEffect(
    () => {
      if (!appToken) return // loadingAnimationStore.showSpinner(true)
      ;(async () => {
        try {
          await Promise.allSettled([
            userStore.getMentionUserList(),
            notificationStore.getUnreadNotificationCount(),
            notificationStore.getUnreadNewsCount(),
            authenticationStore.getCurrentUserAvatar(),
          ])
        } catch (err) {
          console.log(err)
          // message.error(err?.vi || 'Đã có lỗi xảy ra!')
        } finally {
          // loadingAnimationStore.showSpinner(false)
        }
      })()
    },
    [appToken]
  )

  return (
    <Provider {...rootStore}>
      <ThemeProvider>
        <ConfigProvider locale={viVN}>
          <Router history={history}>
            <Switch>
              {normalRoutes.map(route => (
                <Route
                  key={route.path}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              <ProtectedRoute exact path={'/'} component={DashboardPageV2} />
              <ProtectedRoute
                exact
                path={'/dashboard'}
                component={DashboardPageV2}
              />

              {routes.map(route => (
                <ProtectedRoute
                  key={route.path}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              <ProtectedRoute exact path={'/demo'} component={DemoTagPage} />

              <Route component={NotFoundPage} />
            </Switch>
          </Router>
        </ConfigProvider>
        <LoadingSpinner />
        <div
          style={{
            position: 'fixed',
            top: 17,
            right: 10,
            zIndex: 10000000001,
          }}>
          <Report />
        </div>
      </ThemeProvider>
    </Provider>
  )
}

export default App
